import MailboxTable from '@communications/components/tables/mailbox-table/mailbox-table.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-mailbox',
  components: {
    'bpc-mailbox-table': MailboxTable,
  },
})
export default class ProfileMailbox extends Vue {
  // @Prop({ type: [String, Number], required: true}) readonly contactId: string | number;
  public originShowContact: boolean = false;

  get contactId() {
    return this.$authorizationService.getContactId();
  }

  created() {
    this.originShowContact = this.$route.meta['originShowContact'];
  }

  filterByContactId() {
    return [{ filterField: 'received_by_contact_id', modelField: null, value: this.contactId }];
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
